import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { ThemeType } from '@types';
import { UXPContext, createUXPContext } from "@core/context/Context";
import { BrowserRouter } from "react-router";
import { onChangeTheme, defaultThemes, defaultLightTheme } from "@theme/themeUtils";
import { hasValue, parseComponentId } from "@utils";
import { AddOnProvider } from "@helper/AddOn/useAddOns";
import { LoadingFlashAlert } from "@widget/loaders";
import { RouterContextProvider } from "@core/route-context/RouteContext";
import App from '@core/views/App';
import NotificationProvider from "@notifications/NotificationProvider";
import AuthHelperComponent from "@helper/AuthHelper/AuthHelperComponent";
import { ExportEngineBootstrap } from "@hooks/exportEngine";
import UIView from '@core/views/ui-view/UIView';
import ResponsivePage from "./components/UXPRenderPage/ResponsivePage";
export const UXPContextWrapper = ({ children, context, authCheck = false, authCheckInterval = 30 * 1000 }) => {
    const [loading, setLoading] = React.useState(false);
    const [loadingMessage, setLoadingMessage] = React.useState('Loading');
    const [theme, setTheme] = React.useState({
        name: defaultLightTheme,
        config: defaultThemes[defaultLightTheme].props,
        type: ThemeType.Light
    });
    const [viewOverrides, setViewOverrides] = useState({});
    const [objectTabs, setObjectTabs] = useState({});
    React.useEffect(() => {
        const themeName = hasValue(context === null || context === void 0 ? void 0 : context.themeName) ? context.themeName || defaultLightTheme : defaultLightTheme;
        const { name, config, type } = onChangeTheme(themeName, (context === null || context === void 0 ? void 0 : context.customThemes) || {});
        setTheme({ name, config, type });
        setViewOverrides((context === null || context === void 0 ? void 0 : context.viewOverrides) || {});
        setObjectTabs((context === null || context === void 0 ? void 0 : context.objectTabs) || {});
    }, [context]);
    function setLoadingStatus(isLoading, message) {
        setLoading(isLoading);
        setLoadingMessage(message || 'Loading');
    }
    function updateTheme(name, config, type) {
        setTheme({ name, config, type });
    }
    const loginUIRef = React.useRef(null);
    return (_jsx(UXPContext.Provider, { value: createUXPContext(Object.assign(Object.assign({}, context), { isLoading: loading, setLoading: setLoadingStatus, loadingMessage, themeName: theme.name, theme: theme.config, setTheme: updateTheme, viewOverrides: viewOverrides, setViewOverrides: setViewOverrides, objectTabs: objectTabs, setObjectTabs: setObjectTabs })), children: _jsx(AddOnProvider, { children: _jsxs(NotificationProvider, { children: [_jsx(ExportEngineBootstrap, {}), authCheck && (_jsx(AuthHelperComponent, { interval: authCheckInterval, ref: loginUIRef })), loading && _jsx(LoadingFlashAlert, {}), children] }) }) }));
};
export const WrappedApp = ({ context }) => (_jsx(UXPContextWrapper, { context: context, authCheck: true, children: _jsx(BrowserRouter, { children: _jsx(RouterContextProvider, { children: _jsx(App, {}) }) }) }));
export const WrappedUIComponent = ({ context, id, additionalProps }) => {
    // id format: "<moduleId>/<componentId>" (2-part) or "<moduleId>/ui/<componentId>" (3-part legacy)
    const parsed = parseComponentId(id);
    const moduleId = (parsed === null || parsed === void 0 ? void 0 : parsed.moduleId) || '';
    const componentId = (parsed === null || parsed === void 0 ? void 0 : parsed.componentId) || '';
    return (_jsx(UXPContextWrapper, { context: context, authCheck: true, children: _jsx(BrowserRouter, { children: _jsx(RouterContextProvider, { children: _jsx(UIView, { moduleId: moduleId, componentId: componentId, additionalProps: additionalProps }) }) }) }));
};
export const ResponsivePageComponent = ({ context, widget, embedded }) => (_jsx(UXPContextWrapper, { context: context, children: _jsx(BrowserRouter, { children: _jsx(RouterContextProvider, { children: _jsx(ResponsivePage, { widget: widget, embedded: embedded }) }) }) }));
